import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Assignments, GetEmployee, Tag } from 'src/app/core/api/assignment/assignment.model';
import { ApiUrlService } from '../apiUrl/api-url.service';


@Injectable({
    providedIn: 'root'
})
export class AssignmentsService {


    private apiUrl: string;


    constructor(private http: HttpClient, private apiUrlService: ApiUrlService) {
        this.apiUrl = this.apiUrlService.apiAssignmentsEmployeeData();
    }

    //GET EMPLOYEE BY ID
    getEmployeeById(id: number): Observable<any> {

        return this.http.get<GetEmployee>(`${this.apiUrl}${id}`).pipe(
            catchError(this.handleError)
        );
    }

    private handleError(error: HttpErrorResponse) {
        let errorMessage = 'Unknown error!';
        if (error.error instanceof ErrorEvent) {
            // Client-side errors
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // Server-side errors
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        return throwError(() => new Error('Código no Valido'))
    }

}
